import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-add-user-district-popup',
    templateUrl: './add-user-district-popup.component.html',
    styleUrls: ['./add-user-district-popup.component.scss'],
})
export class AddUserDistrictPopupComponent implements OnInit {
    userDistrict: FormGroup;
    submitted = false;
    userId: any;
    planId: any;
    isLoading = false;
    District: any[] = [];
    // State: any[] = [];
    // StateList_1: any[] = [];

    constructor(
        private fb: FormBuilder,
        private service: GeneralService,
        public dialogRef: MatDialogRef<AddUserDistrictPopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.userId = data.userId || localStorage.getItem('UserId');
        this.planId = data.planId || localStorage.getItem('PlanId');
    }

    ngOnInit(): void {
        this.userDistrict = this.fb.group({
            UserID: new FormControl(this.userId),
            DistrictID: new FormControl(null, Validators.required),
            // StateID: new FormControl(null, Validators.required),
        });

        this.fetchdistrictlist();
    }

    get f() {
        return this.userDistrict.controls;
    }

    fetchdistrictlist() {
        this.service.viewDistrictlist().subscribe((res: any) => {
            this.District = res;
        });
    }

    save1() {
        this.submitted = true;

        if (this.userDistrict.valid) {
            const districtId = this.userDistrict.value.DistrictID;

            const matchedDistrict = this.District.find(
                (d) => d.DistrictID === districtId
            );

            if (!matchedDistrict) {
                Swal.fire({
                    type: 'error',
                    title: 'Invalid District',
                    text: 'The selected district is not valid. Please choose again.',
                });
                return;
            }

            const payload = {
                UserID: this.userId,
                DistrictID: districtId,
            };

            this.isLoading = true;

            this.service.addUserDistrict(payload).subscribe((res: any) => {
                this.isLoading = false;
                this.submitted = false;

                if (res.status == 200) {
                    Swal.fire({
                        position: 'top-end',
                        type: 'success',
                        title: 'User district added successfully',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    this.dialogRef.close(true);
                } else {
                    Swal.fire({
                        position: 'top-end',
                        type: 'info',
                        title: res.message || 'Failed to add district',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }

                this.userDistrict.reset();
            });
        }
    }

    resetFields() {
        this.userDistrict.reset();
        this.submitted = false;
    }

    close(): void {
        this.dialogRef.close();
    }
}
